import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import "./Article.scss"
import { vPush } from "../Services/Analytics"
import HeaderArticle from '../Header/HeaderArticle';
import ArticleContent from '../Screens/ArticleContent/ArticleContent';
import Loading from "../Services/Loading/Loading"
import { ArticlesApi } from '../Services/Fetch/article';
import Footer from '../Footer/Footer';
import Popup from '../Helpers/Popup/Popup';
import Readmore from '../Screens/5_Playbuzz/Readmore/Readmore';
import Landscape from '../Helpers/Landscape/Landscape';

class Article extends Component {
    constructor(props) {
        super();
        this.togglePopup = this.togglePopup.bind(this);
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            articleHtml: '',
            isLoading: true,
            redirect: false,
            isPopupActive: false,
            popupContext: null,
            popupClass: null
        };
    }
    async componentDidMount() {
        await this.initPage(this.props.match.params.id);
    }
    async componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id === this.props.match.params.id) return;

        this.setState(this.getInitialState());
        await this.initPage(nextProps.match.params.id);
    }
    async initPage(ArticleID) {
        vPush(`Article #${ArticleID}`, (window.location.href).replace(window.location.origin, "").replace("/#", ""));
        const _articleHtml = await ArticlesApi.get(ArticleID);

        this.setState({
            articleHtml: _articleHtml,
            isLoading: false,
            articleID: ArticleID
        });
        window.scrollTo(0, 0);
        var _body = window.document.body;
        if (_body.className && _body.className.indexOf("lg-home-screen") > -1) {
            _body.className = _body.className.replace("lg-home-screen", "");
        }
    }
    togglePopup(_class, _className) {
        this.setState({
            isPopupActive: !this.state.isPopupActive
        })
        if (_class != "") {
            this.setState({
                popupContext: _class,
                popupClass: _className
            })
        }
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={{ pathname: '/' }} />
            )
        }
        const teaserText = ["לרכישת המכשיר עם מצלמת הבינה המלאכותית", "לרכישת המכשיר עם בהירות מסך גבוהה וצלולה"];
        return (
            <div className="ArticlePage">
                <Landscape />
                <Popup
                    isActive={this.state.isPopupActive}
                    context={this.state.popupContext}
                    className={this.state.popupClass}
                    togglePopup={this.togglePopup} />
                <HeaderArticle />
                <div className="article">
                    <section className="section section-article">
                        <div className="padding">
                            <div className="container">
                                <Loading showLoading={this.state.isLoading} />
                                <ArticleContent html={this.state.articleHtml} />
                            </div>
                        </div>
                    </section>
                </div>
                {this.state.articleID == 2 ?
                <Readmore
                    teaserText={teaserText[this.state.articleID - 1]}
                    togglePopup={this.togglePopup} />: null}
                <Footer />
            </div>
        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/App/Article.jsx